<template>
  <div>
    <modal name="photo-download-dialog"
      :draggable="false" :resizable="false"
      :clickToClose="false"
      :width="'90%'"
      :height="'90%'"
      :max-width="900"
      :adaptive="true"
      ref="modal"
      @opened="opened">
      <div class="modal-header">
        <button class="close" @click="hide">×</button>
      </div>
      <div class="modal-body">
        <div class="back-wrap">
          <button class="back-button"
                  :disabled="image.prevFrameKey == null"
                  @click="$emit('change-img', image.prevFrameKey)">
            <img v-if="image.prevFrameKey != null" class="back-button-img" src="@/assets/arrow_left.svg">
            <img v-else class="back-button-img" src="@/assets/arrow_left_disabled.svg">
          </button>
        </div>
        <div class="contents-wrap" id="photoDlModalContentsWrap">
          <div class="photo-wrap" id="photoDlModalPhotoWrap">
            <div class="photo-square">
              <img :src="image.thumbnail_l_url" class="photo" @error="initUrls(image, true)">
            </div>
          </div>
          <div class="info-wrap" id="photoDlModalInfoWrap">
            <div class="info-table">
              <div class="info-table-cell">
                <div v-for="kokubanInfo in kokubanInfoList" :key="kokubanInfo.index" class="kokuban-info">
                  <span v-if="kokubanInfo.title">
                    {{ kokubanInfo.title }}:{{ kokubanInfo.value }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="next-wrap">
          <button class="next-button"
                  :disabled="image.nextFrameKey == null"
                  @click="$emit('change-img', image.nextFrameKey)">
            <img v-if="image.nextFrameKey != null" class="next-button-img" src="@/assets/arrow_right.svg">
            <img v-else class="next-button-img" src="@/assets/arrow_right_disabled.svg">
          </button>
        </div>
      </div>
      <div class="modal-footer">
        <a v-if="!noDownload" :href="image.original_url" class="button dl-button" :disabled="!image.original_url">
          <span class="dl-button-text">写真をダウンロード</span>
        </a>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal);

export default {
  name: 'PhotoDownloadDialog',
  props: {
    noDownload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      image: {
        thumbnail_l_url: '',
        original_url: '',
        prevFrameKey: null,
        nextFrameKey: null,
      },
      windowSize: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  computed:{
    kokubanInfoList(){
      return this.kokubanParam(this.image.kokuban_info_json);
    }
  },
  methods: {
    // 表示用とダウンロード用のURLを取得する
    async initUrls(image, forceInit = false){
      const photoIds = []
      if (!('thumbnail_l_url' in image) || forceInit) {
        photoIds.push({photo_key: image.photo_key, extension: image.extension, image_type: 'thumbnail_l'});
      }
      if (!('original_url' in image) || forceInit) {
        photoIds.push({photo_key: image.photo_key, extension: image.extension, image_type: 'original', for_download: true});
      }

      if(0 < photoIds.length){
        const args = {
          cloud_construction_id: this.$route.params.cloudConstructionId,
          photo_ids: photoIds,
          return_type: 'array',
          __apiOptions: { noDisplayLoading: true }
        }
        const photoUrls = await this.$store.dispatch('aws/photoUrlsOf', args);
        //console.log(photoUrls);
        photoUrls.forEach(([photoId, url]) => {
          this.$set(image, `${photoId.image_type}_url`, url)
        })
      }
      return image;
    },
    show(image) {
      this.initUrls(image).then(img => {
        this.image = img;
        this.$modal.show('photo-download-dialog');
      })
    },
    opened() {
      // 初回のウィンドウ縦横比チェック
      const width = window.innerWidth;
      const height = window.innerHeight;
      const contentsWrapElem = document.getElementById("photoDlModalContentsWrap");
      const photoWrapElem = document.getElementById("photoDlModalPhotoWrap");
      const infoWrapElem = document.getElementById("photoDlModalInfoWrap");
      if (height <= width) {
        // ウィンドウが横長の場合
        contentsWrapElem.classList.remove("vertical");
        photoWrapElem.classList.remove("vertical");
        infoWrapElem.classList.remove("vertical");
      } else {
        // ウィンドウが縦長の場合
        contentsWrapElem.classList.add("vertical");
        photoWrapElem.classList.add("vertical");
        infoWrapElem.classList.add("vertical");
      }
    },
    changeTo(image){
      this.initUrls(image).then(img => {
        this.image = img;
      })
    },
    hide() {
      this.$modal.hide('photo-download-dialog');
    },
    onResize(){
      this.windowSize.width = window.innerWidth;
      this.windowSize.height = window.innerHeight;
    },
    kokubanParam(kokubanInfoJson) {
      try{
        const kokubanInfoObj = JSON.parse(kokubanInfoJson);
        if (kokubanInfoObj.kokuban_param) {
          return kokubanInfoObj.kokuban_param
            .filter(elem => (elem.title))
            .sort((a, b) => (a.index - b.index))
            ;
        }
        return []
      }catch(e){
        return []
      }
    }
  },
  watch: {
    windowSize: {
      handler(newSize) {
        const width = newSize.width;
        const height = newSize.height;
        const contentsWrapElem = document.getElementById("photoDlModalContentsWrap");
        const photoWrapElem = document.getElementById("photoDlModalPhotoWrap");
        const infoWrapElem = document.getElementById("photoDlModalInfoWrap");
        if (!contentsWrapElem || !photoWrapElem || !infoWrapElem) return;
        if (height <= width) {
          // ウィンドウが横長の場合
          contentsWrapElem.classList.remove("vertical");
          photoWrapElem.classList.remove("vertical");
          infoWrapElem.classList.remove("vertical");
        } else {
          // ウィンドウが縦長の場合
          contentsWrapElem.classList.add("vertical");
          photoWrapElem.classList.add("vertical");
          infoWrapElem.classList.add("vertical");
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
}
</script>

<style scoped>
/* モーダル */
.modal-header {
    padding: 15px 25px;
    height: 50px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;
}
.modal-header .close {
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: 0;
    float: right;
    font-size: 21px;
    font-weight: bold;
    line-height: 1;
    color: #707070;
}
.modal-footer {
    clear: left;
    padding: 5px 25px;
    text-align: center;
}
.modal-footer .button {
    margin: 10px;
    padding: 8px 0;
    border-radius: 6px;
    text-align: center;
    background: #333 0% 0% no-repeat;
    border: none;
    color: white;
    opacity: 1;
    cursor: pointer;
    width: 200px;
    position: relative;
    z-index: 1010;
}
.dl-button {
  display: inline-block;
  text-decoration: none;
}
.modal-footer .button[disabled] {
    opacity: 0.3;
}
.modal-footer .button:hover {
	opacity: 0.5 ;
}
.modal-body {
  height: calc(100% - 50px - 70px);
}
.back-wrap,
.next-wrap {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 60px;
  height: 100%;
  line-height: 100%;
  padding: 10px;
  text-align: center;
}
.back-wrap {
  z-index: 1020;
}
.next-wrap {
  z-index: 1030;
}
.contents-wrap {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 120px);
  height: 100%;
  padding: 5px;
}
.contents-wrap.vertical {
  /* 画面縦長の場合は全体をスクロール可にする */
  overflow-y: auto;
}
.photo-wrap {
  width: 70%;
  height: 100%;
  position: relative;
}
.photo-wrap.vertical {
  /* 画面縦長の場合は100% */
  width: 100%;
  height: auto;
}
.photo-wrap::before {
  content: "";
  display: block;
  padding-top: 100%;
}
.photo-square {
  /* 写真表示用の正方形 */
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}
.photo-square .photo {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-width: calc(100% - 10px);
  max-height: calc(100% - 10px);
  width: auto;
  height: auto;
}
.info-wrap {
  width: 30%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  /* スクロール可 */
  overflow-y: auto;
}
.info-wrap.vertical {
  /* 画面縦長の場合は100%、スクロールは全体に任せるのでunset */
  width: 100%;
  height: auto;
  position: relative;
  overflow-y: unset;
}
.info-table {
  display: table;
  width: 100%;
  height: 100%;
}
.info-table-cell {
  display: table-cell;
  vertical-align: middle;
}
.kokuban-info {
  line-height: 1.5;
}
.back-button,
.next-button {
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
}
</style>